import { t } from 'ember-intl';
import Avatar from '../avatar.gjs';
import Checkbox from 'ember-simplepractice/components/spds/input/checkbox';
import Component from '@glimmer/component';
import styles from './item-content.module.scss';

export default class ContactListItemItemContent extends Component {
  handleCheckboxClick = ({ event }) => {
    // Since the list item click handler already handles state toggling, we need
    // to both prevent propagation and prevent default to avoid double toggling.
    event.target.blur();
    event.stopPropagation();
    event.preventDefault();
  };

  <template>
    <div class={{styles.component}}>
      <Avatar @users={{@users}} @isCouple={{@isCouple}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{@userNames}}</span>
          {{#if @showCheckbox}}
            <Checkbox
              @checked={{@isSelected}}
              @onClick={{this.handleCheckboxClick}}
              aria-label={{t "emc.contact_list_item.select_aria_label" userNames=@userNames}}
              class="selection-checkbox"
            />
          {{/if}}
        </div>
        {{#if @isDisabled}}
          <span class="disabled-notice" data-test-disabled-notice>
            {{t "emc.contact_list_item.disabled_notice"}}
          </span>
        {{/if}}
      </div>
    </div>
  </template>
}
